import * as React from "react";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../../hocs/enhanceSectionsSettingsPage";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import SectionsSettingsGoogleClassroom from "./SectionsSettingsGoogleClassroom";

interface Props extends OutletContextProps {
  section: SectionInterface;
  operator: OperatorInterface;
}

const SectionsSettingsGoogleClassroomLinkPage: React.FC<Props> = (props) => {
  React.useEffect(() => {
    props.setActiveMenu("applications");
  }, []);
  return (
    <SectionsSettingsGoogleClassroom
      section={props.section}
      operator={props.operator}
    />
  );
};

const pageInfo = {
  title: "アプリ連携",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsGoogleClassroomLinkPage,
  pageInfo,
  ["third_party_application:settings"],
);
